import {StorageService} from "../../Services/StorageService";
import {ISendQueueEntry} from "../../Services/ISendQueueEntry";
import {TimeQueueItem} from "../../Services/TimeQueueItem";
import {environment} from '../../../Environments/environment';

export class DebugController {

  static controllerId = 'DebugController';
  static $inject = ['$state', StorageService.serviceId];

  filter: string;
  url: string = '';

  selectedTab: string = 'p';

  entries: ISendQueueEntry[] = [];

  latestEntries: { [key: string]: TimeQueueItem } = {};

  constructor(private $state, private storage: StorageService) {
    this.init();
  }


  selectTab(tabId: string) {
    this.selectedTab = tabId;
  }

  init() {
    this.url = environment.webApiUrl;
    this.entries = this.storage.getEntryQueue();
    this.latestEntries = this.storage.getLatestEntryMap();
  }

  back() {
    this.$state.go('main'); //TODO
  }
}